<table mat-table [dataSource]="dataSource!" matSort class="mat-elevation-z8">

    <ng-container matColumnDef="batteryVoltage">
        <th mat-header-cell *matHeaderCellDef>Akkuspannung </th>
        <td mat-cell *matCellDef="let element"> {{element.batteryVoltage}} </td>
    </ng-container>

    <ng-container matColumnDef="blinkerIndicator">
        <th mat-header-cell *matHeaderCellDef> Blinker </th>
        <td mat-cell *matCellDef="let element"> {{element.blinkerIndicator}} </td>
    </ng-container>

    <ng-container matColumnDef="brightness">
        <th mat-header-cell *matHeaderCellDef> Helligkeit </th>
        <td mat-cell *matCellDef="let element"> {{element.brightness }} </td>
    </ng-container>

    <ng-container matColumnDef="triggerName">
        <th mat-header-cell *matHeaderCellDef> Auslösername </th>
        <td mat-cell *matCellDef="let element"> {{element.triggerName}} </td>
    </ng-container>

    <ng-container matColumnDef="trigger">
        <th mat-header-cell *matHeaderCellDef> Auslöser </th>
        <td mat-cell *matCellDef="let element"> {{element.trigger }} </td>
    </ng-container>

    <ng-container matColumnDef="deviceName">
        <th mat-header-cell *matHeaderCellDef> SST </th>
        <td mat-cell *matCellDef="let element"> {{element.deviceName}} </td>
    </ng-container>

    <ng-container matColumnDef="lineDescribtion">
        <th mat-header-cell *matHeaderCellDef> Standort </th>
        <td mat-cell *matCellDef="let element"> {{element.lineDescribtion}} </td>
    </ng-container>

    <ng-container matColumnDef="ledStellcode">
        <th mat-header-cell *matHeaderCellDef> Stellcode </th>
        <td mat-cell *matCellDef="let element"> {{element.ledStellcode }} | {{ element.ledIndicator }} </td>
    </ng-container>

    <ng-container matColumnDef="timestamp">
        <th mat-header-cell *matHeaderCellDef> Zeit (von) </th>
        <td mat-cell *matCellDef="let element"> {{element.timestamp | date: 'dd.MM.yyyy - H:mm'}} </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>